import {
  customScrollMinimal,
  Pagination,
  SmartTable,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  ${customScrollMinimal};
  overflow: scroll;
  ${SmartTable.Styled.TableRow} {
    &:hover {
      background-color: var(--surface-default);
      td {
        background-color: var(--surface-default);
      }
    }
  }
  ${SmartTable.Styled.StickyTableHeader} {
    && {
      gap: 8px;
      background: red;
    }
  }
`;

export const TickerColumnHeader = styled.div`
  padding-left: 30px;
`;

export const TickerColumnContent = styled.div`
  width: 120px;
  display: flex;
  gap: 8px;
`;

export const TickerColumnImg = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  object-fit: contain;
`;

export const LogoPlaceHolder = styled.span`
  min-width: 20px;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background: var(--surface-neutral);
  text-align: center;
  ${typographyV2.bodySm}
`;

export const StyledPagination = styled(Pagination)`
  max-width: fit-content;
  margin-left: auto;
  margin-right: auto;
  margin-top: 16px;
`;
